import Link from '@components/Link'

export const RequestHelp = () => {
    return (<Link external target={'blank'} href={'https://digitalplatforms.totalenergies.com'}>Resquest help</Link>)
}

export default RequestHelp